import {
  Box,
  FormControlLabel,
  Radio,
  Typography,
  useTheme,
} from "@mui/material";

interface Props {
  checked?: boolean;
  str: string;
  qId: string;
  selected: string;
  score: number;
  handleAnswer: (qId: string, selected: string, score: number) => void;
}

export default function ChoiceCard(props: Props) {
  const { str, handleAnswer, qId, selected, score } = props;
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.bgColor.white,
        borderRadius: "8px",
        border: "1px solid gray",
      }}
    >
      <FormControlLabel
        sx={{
          margin: 0,
        }}
        value={str}
        control={
          <Radio
            checked={selected === str}
            onChange={(e) => handleAnswer(qId, e.target.value, score)}
            name={str}
            color="secondary"
            size="small"
          />
        }
        label={
          <Typography
            sx={{
              fontSize: "14px",
            }}
          >
            {str}
          </Typography>
        }
      />
    </Box>
  );
}
